import React from 'react';
import PostCardSkeleton from './PostCardSkeleton';

const SkeletonLoader = ({ count = 4 }) => (
  <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
    {[...Array(count)].map((_, index) => (
      <PostCardSkeleton key={index} />
    ))}
  </div>
);

export default SkeletonLoader;
